module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_02.91c7733a.jpg";